<template>
    <div class="Category">
        <div class="Category_inner">
            <div class="Select">
                <el-input size="medium" style="width: 180px;margin-right: 5px" v-model="searchInfo.phone"
                    placeholder="联系方式"></el-input>
                <el-select v-model="searchInfo.releasetype" placeholder="发布者类型" size="medium"
                    style="width: 180px;margin-right: 5px" clearable>
                    <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="searchInfo.isdelete" placeholder="活动状态" size="medium"
                    style="width: 180px;margin-right: 5px" clearable>
                    <el-option v-for="item in delList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="searchInfo.examinestate" placeholder="审核状态" size="medium"
                    style="width: 180px;margin-right: 5px" clearable>
                    <el-option v-for="item in examinestateList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-button type="primary" size="medium" @click="GetaavolunteeractivityList">查询
                </el-button>
                <el-button style="float: right" type="primary" size="medium" @click="add">新增</el-button>

            </div>
            <div>
                <el-table :data="pageList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="aavolunteeractivityId" label="ID" v-if="true" align="center" width="50">
                    </el-table-column>
                    <el-table-column prop="activityname" label="活动名称" align="center" width="200px">
                    </el-table-column>
                    <el-table-column prop="name" label="姓名" align="center" width="150px">
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" width="100px" :show-overflow-tooltip="true" sortable align="center">
                    </el-table-column>
                    <el-table-column prop="gender" label="性别" align="center" width="50px">
                    </el-table-column>
                    <el-table-column prop="address" label="地址" align="center">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机" align="center" width="120px">
                    </el-table-column>
                    <el-table-column prop="needs" label="服务需求" align="center">
                    </el-table-column>
                    <el-table-column prop="userId" label="发布人" :show-overflow-tooltip="true" align="center"
                        width="150px">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.userId == 999999">管理员</span>
                                <span v-else>志愿者</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="isdelete" label="活动状态" align="center" :show-overflow-tooltip="true"
                        width="80px">
                        <template slot-scope="scope">
                            <div>
                                <el-button v-if="scope.row.isdelete == 1" @click="closeDelete(scope.row)" size="small"
                                    type="success">开启</el-button>
                                <el-button v-if="scope.row.isdelete == 2" @click="openDelete(scope.row)" size="small"
                                    type="danger">停止</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="examinestate" label="审核状态" align="center" :show-overflow-tooltip="true"
                        width="80px">
                        <template slot-scope="scope">
                            <div>
                                <el-tag v-if="scope.row.examinestate == 1" type="success">通过</el-tag>
                                <el-tag v-if="scope.row.examinestate == 2" type="danger">拒绝</el-tag>
                                <el-tag v-if="scope.row.examinestate == 3">审核中</el-tag>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" align="center" width="250">
                        <template slot-scope="scope">
                            <el-button class="edit_btn" type="primary" size="mini"
                                @click="getaavolunteerlist(scope.row.aavolunteeractivityId)">查看参与人</el-button>
                            <el-button class="edit_btn" type="primary" size="mini"
                                @click="handleUpdate(scope.row)">编辑</el-button>
                            <el-button class="edit_btn" v-if="scope.row.examinestate != 3" type="info"
                                size="mini">审核</el-button>
                            <el-button v-if="scope.row.examinestate == 3" class="edit_btn" type="warning" size="mini"
                                @click="openSetState(scope.row)">审核</el-button>
                            <!--<el-button class="del_btn" size="mini" @click="del(scope)">删除</el-button>-->
                        </template>
                    </el-table-column>

                </el-table>
            </div>
            <!--弹框-->
            <div>
                <el-dialog :title="title" :visible.sync="isShow" width="800px" top="20vh" custom-class="pop-dialog"
                    :before-close="oncancel">
                    <el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"
                        class="demo-ruleForm" style="width: 100%">

                        <el-form-item label="活动名称: " prop="activityname">
                            <el-input size="small" v-model="formData.activityname"></el-input>
                        </el-form-item>

                        <el-form-item label="姓名: " prop="name">
                            <el-input size="small" v-model="formData.name"></el-input>
                        </el-form-item>

                        <el-form-item label="年龄: " prop="age">
                            <el-input size="small" v-model="formData.age"></el-input>
                        </el-form-item>
                        <el-form-item label="性别: " prop="gender">
                            <el-select v-model="formData.gender" placeholder="请选择" size="small">
                                <el-option v-for="item in genderList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="家庭住址: " prop="address">
                            <el-input size="small" v-model="formData.address"></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式: " prop="phone">
                            <el-input size="small" v-model="formData.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="服务需求: " prop="needs">
                            <el-input size="small" v-model="formData.needs"></el-input>
                        </el-form-item>
                        <el-form-item label="备注: " prop="remarks">
                            <el-input size="small" v-model="formData.remarks"></el-input>
                        </el-form-item>
                        <el-form-item label="上传图片:" prop="image" class="higher">
                            <upload ref="postUpload" :defaultUrl.sync="formData.image" style="margin-left: 100px" />
                        </el-form-item>
                    </el-form>
                    <div style="margin-top: 25px; width: 100%; text-align: center">
                        <el-button @click="oncancel" size="small" class="cancel"
                            style="background: rgba(231, 231, 231, 1)">取消
                        </el-button>
                        <el-button type="primary" @click="onSave" size="small" class="onSave"
                            style="background: rgba(201, 160, 108, 1)">确 定
                        </el-button>
                    </div>
                    <br />
                </el-dialog>
            </div>

            <!--<div>-->
            <!--<el-dialog  :title="title" :visible.sync="isShowedit"-->
            <!--width="800px"  top="20vh" custom-class="pop-dialog" :before-close="cancel">-->
            <!--<el-form :model="formData" label-position="right" label-width="120px" :rules="rules" ref="formData"-->
            <!--class="demo-ruleForm" style="width: 100%">-->

            <!--<el-form-item label="标题: " prop="title">-->
            <!--<el-input size="small" v-model="formData.title"></el-input>-->
            <!--</el-form-item>-->

            <!--<el-form-item label="排序: " prop="listOrder">-->
            <!--<el-input size="small" v-model="formData.listOrder"></el-input>-->
            <!--</el-form-item>-->

            <!--<el-form-item label="详细描述: " prop="description">-->
            <!--<el-input size="small" v-model="formData.description"></el-input>-->
            <!--</el-form-item>-->
            <!--<el-form-item label="家属/患者: " style="margin-top: 16px">-->
            <!--<el-select-->
            <!--v-model="formData.for"-->
            <!--placeholder="请选择"-->
            <!--size="small"-->
            <!--value-key="id">-->
            <!--<el-option-->
            <!--v-for="item in options"-->
            <!--:key="item.value"-->
            <!--:label="item.label"-->
            <!--:value="item.value"-->
            <!--&gt;-->
            <!--</el-option>-->
            <!--</el-select>-->
            <!--</el-form-item>-->

            <!--<el-form-item label="上传图片:" prop="posterSrc" class="higher">-->
            <!--<upload ref="postUpload" :defaultUrl.sync="formData.posterSrc" style="margin-left: 100px"/>-->
            <!--</el-form-item>-->

            <!--<el-form-item label="上传视频: " prop="videoSrc" class="higher">-->
            <!--<upload1 ref="postUpload1" :isVideo="2"-->
            <!--:defaultUrl.sync="formData.videoSrc" style="margin-left: 100px"/>-->
            <!--</el-form-item>-->

            <!--</el-form>-->
            <!--<div style="margin-top: 25px; width: 100%; text-align: center">-->
            <!--<el-button-->
            <!--@click="cancel"-->
            <!--size="small"-->
            <!--class="cancel"-->
            <!--style="background: rgba(231, 231, 231, 1)"-->
            <!--&gt;取消-->
            <!--</el-button>-->
            <!--<el-button-->
            <!--type="primary"-->
            <!--@click="onSaveedit"-->
            <!--size="small"-->
            <!--class="onSave"-->
            <!--style="background: rgba(201, 160, 108, 1)"-->
            <!--&gt;确 定-->
            <!--</el-button>-->
            <!--</div>-->
            <!--<br/>-->
            <!--</el-dialog>-->
            <!--</div>-->
        </div>
        <div>
            <el-dialog title="审核状态" :visible.sync="stateFlag" width="800px" top="20vh" custom-class="pop-dialog"
                :before-close="oncancel2">
                <el-form :model="examinestateData" label-position="right" label-width="120px" :rules="rules"
                    ref="examinestateData" class="demo-ruleForm" style="width: 100%">
                    <el-form-item label="审核状态: " style="margin-top: 16px">
                        <el-select v-model="examinestateData.examinestate" placeholder="请选择" size="small" value-key="id">
                            <el-option v-for="item in statesList" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div style="margin-top: 25px; width: 100%; text-align: center">
                    <el-button @click="oncancel2" size="small" class="cancel" style="background: rgba(231, 231, 231, 1)">取消
                    </el-button>
                    <el-button type="primary" @click="setexaminestate" size="small" class="onSave"
                        style="background: rgba(201, 160, 108, 1)">确 定
                    </el-button>
                </div>
                <br />
            </el-dialog>
        </div>
        <div>
            <el-dialog title="参与人列表" :visible.sync="teerListFlag" width="80%" top="20vh" custom-class="pop-dialog"
                :before-close="oncancel3">
                <el-table :data="teerList" style="width: 100%" max-height="520px">
                    <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                    <el-table-column prop="name" label="姓名" align="center" width="150px">
                    </el-table-column>
                    <el-table-column prop="phone" label="手机号" align="center">
                    </el-table-column>
                    <el-table-column prop="age" label="年龄" sortable align="center">
                    </el-table-column>
                    <el-table-column prop="gender" label="性别" align="center">
                    </el-table-column>
                    <el-table-column prop="job" label="工作" align="center">
                    </el-table-column>
                    <el-table-column prop="address" label="地址" align="center">
                    </el-table-column>
                    <el-table-column prop="region" label="区域" align="center">
                    </el-table-column>
                    <el-table-column prop="remarks" label="备注" align="center">
                    </el-table-column>
                </el-table>
                <div style="margin-top: 25px; width: 100%; text-align: center">
                    <el-button @click="oncancel3" size="small" class="cancel" style="background: rgba(231, 231, 231, 1)">关闭
                    </el-button>
                </div>
                <br />
            </el-dialog>
        </div>
    </div>
</template>

<script>
import upload1 from 'components/FileUpload2'
import upload from 'components/FileUpload'


//import {GetVideopageList} from '@/assets/js/api'
import { GetaavolunteeractivityList, getaavolunteeractivityone, setexaminestate, setisdelete, updateaavolunteeractivity } from '@/assets/js/api'
import { GetcategorybyformovieList, getaavolunteerlist } from '@/assets/js/api'
import { setadminaavolunteeractivity } from '@/assets/js/api'
import { SaveeditVideo } from '@/assets/js/api'

export default {
    data: () => ({
        image: '',
        searchInfo: {
            phone: '',
            releasetype: '',
            isdelete: '',
            examinestate: ''
        },
        pageList: [],
        categoryList: [],
        typeList: [
            {
                value: '1',
                label: '管理员'
            },
            {
                value: '2',
                label: '志愿者'
            },
        ],
        delList: [
            {
                value: '1',
                label: '开启'
            },
            {
                value: '2',
                label: '关闭'
            },
        ],
        examinestateList: [
            {
                value: '1',
                label: '通过'
            },
            {
                value: '2',
                label: '拒绝'
            }, {
                value: '3',
                label: '审核中'
            },
        ],
        genderList: [
            {
                value: '男',
                label: '男'
            }, {
                value: '女',
                label: '女'
            },
        ],
        options: [
            {
                value: '患者',
                label: '患者'
            },
            {
                value: '家属',
                label: '家属'
            }
        ],
        statesList: [
            {
                label: '通过',
                value: '1'
            },
            {
                label: '拒绝',
                value: '2'
            }
        ],
        // 弹窗
        isShow: false,
        isShowedit: false,
        title: '',
        formData: {
            activityname: '',
            name: '',
            age: '',
            gender: '',
            address: '',
            phone: '',
            needs: '',
            remarks: '',
            image: '',
            aavolunteeractivityId: '',
        },
        rules: {
            title: [
                {
                    required: true,
                    message: '请输入标题',
                    trigger: 'change',
                },
            ],
            listOrder: [
                {
                    required: true,
                    message: '请输入排序数字',
                    trigger: 'change',
                },
            ],

        },
        // 首页优先显示开关
        Id: 0,
        IsOnline: false,
        stateFlag: false,
        examinestateData: {
            aavolunteeractivityId: '',
            examinestate: ''
        },
        teerListFlag: false,
        treeList: []
    }),
    components: {
        upload, upload1,
    },
    created() {
        this.GetaavolunteeractivityList()
        this.GetcategorybyformovieList()
    },

    mounted() {

    },
    methods: {
        // 根据活动查询参与人员
        getaavolunteerlist(id) {
            getaavolunteerlist(id).then(res => {
                this.teerList = []
                this.teerList = res.data.activitylistData
                this.teerListFlag = true
            })
        },
        // 修改审核状态
        setexaminestate() {
            setexaminestate(this.examinestateData).then(res => {
                if (res.data.code == -1) {
                    this.$message.error(res.data.msg)
                    return
                }
                this.GetaavolunteeractivityList()
                this.oncancel2()
            })
        },
        closeDelete(row) {
            let formData = {
                aavolunteeractivityId: row.aavolunteeractivityId,
                isdelete: 2
            }
            setisdelete(formData).then(res => {
                this.$message({
                    type: 'success',
                    message: '上线成功!'
                });
                this.GetaavolunteeractivityList()
            })
        },
        openDelete(row) {
            let formData = {
                aavolunteeractivityId: row.aavolunteeractivityId,
                isdelete: 1
            }
            this.$confirm('确定上线该活动吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                setisdelete(formData).then(res => {
                    this.$message({
                        type: 'success',
                        message: '上线成功!'
                    });
                    this.GetaavolunteeractivityList()
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        // 打开审核弹窗
        openSetState(row) {
            this.examinestateData.aavolunteeractivityId = row.aavolunteeractivityId
            this.stateFlag = true
        },
        // 获取数据
        GetaavolunteeractivityList() {
            console.log('111111111111' + this.searchInfo)
            GetaavolunteeractivityList(this.searchInfo).then(res => {
                //console.log('22222222222222---'+res.data.videoArr)
                //if (res.data.ReturnCode == 0) {
                this.pageList = null;
                this.pageList = res.data.resultfindAll
                // } else {
                //     this.CategoryList = []
                // }
            })
        },
        // 获取详情
        getaavolunteeractivityone(aavolunteeractivityId) {
            console.log('id=' + aavolunteeractivityId)
            getaavolunteeractivityone({ aavolunteeractivityId: aavolunteeractivityId }).then(res => {
                console.log(res)
                this.formData = res.data.resultfindOne
            })
        },
        // 获取movie类型数据
        GetcategorybyformovieList() {
            console.log('111111111111' + this.searchInfo.for)
            GetcategorybyformovieList().then(res => {
                //if (res.data.ReturnCode == 0) {
                this.categoryList = res.data.categorys
                // } else {
                //     this.CategoryList = []
                // }
            })
        },
        onReset() {
            this.$refs.postUpload.clearFiles()
            this.$refs.postUpload1.clearFiles()
            this.$refs.fm.resetFields()
        },
        add() {
            this.isShow = true
            this.title = '新增'
        },
        batchUpload(refs) {
            let promiseArr = [];
            refs.map(r => {
                promiseArr.push(
                    new Promise((resolve, reject) => {
                        r.startupload(() => {
                            resolve();
                        });
                    })
                );
            });
            return Promise.all(promiseArr);
        },
        batchUpload1(refs) {
            let promiseArr = [];
            refs.map(r => {
                promiseArr.push(
                    new Promise((resolve, reject) => {
                        r.startupload(() => {
                            resolve();
                        });
                    })
                );
            });
            return Promise.all(promiseArr);
        },
        onSave() {
            this.$refs.formData.validate((valid) => {
                if (!valid) return false
                this.batchUpload([this.$refs.postUpload]).then(() => {
                    if (!this.formData.aavolunteeractivityId) {
                        this.formData.aavolunteeractivityId = 0;
                        setadminaavolunteeractivity(this.formData).then((res) => {
                            console.log('setadminaavolunteeractivity-------' + res.data.code)
                            if (res.data.code != -1) {
                                this.$message.success('保存成功')
                                this.oncancel()
                                this.GetaavolunteeractivityList()
                            } else {
                                this.$message.success('保存失败,检查是否名称重复和没有填全资料')
                            }
                        })
                    } else {
                        updateaavolunteeractivity(this.formData).then((res) => {
                            console.log('updateaavolunteeractivity-------' + res.data.code)
                            if (res.data.code != -1) {
                                this.$message.success('保存成功')
                                this.oncancel()
                                this.GetaavolunteeractivityList()
                            } else {
                                this.$message.success('保存失败,检查是否名称重复和没有填全资料')
                            }
                        })
                    }

                })
            })
        },

        oncancel() {
            this.isShow = false
            this.isShowedit = false
            this.formData = {
                activityname: '',
                name: '',
                age: '',
                gender: '',
                address: '',
                phone: '',
                needs: '',
                remarks: '',
                image: '',
                aavolunteeractivityId: '',
            }
        },
        oncancel2() {
            this.stateFlag = false
        },
        oncancel3() {
            this.teerListFlag = false
        },
        //编辑
        handleUpdate(row) {
            this.isShow = true;
            this.title = '编辑'
            // this.formData = row
            this.getaavolunteeractivityone(row.aavolunteeractivityId)
        }
    },

}
</script>

<style lang="scss" scoped>
.Category {
    padding: 20px 20px 10px;

    .Category_inner {
        padding: 20px 30px 30px 30px;
        width: calc(100% - 60px);
        min-height: calc(100vh - 155px);
        background: #fff;
        display: flex;
        flex-direction: column;
        font-size: 12px !important;

        .breadcrumb {
            align-items: center;
            justify-content: center;

            .el-breadcrumb {
                font-size: 15px;
                line-height: 2;
            }
        }
    }
}

.SortManagement {
    padding: 20px 20px 10px;

    .SortManagement_inner {
        padding: 30px;
        width: calc(100% - 60px);
        min-height: calc(100vh - 155px);
        background: #fff;
        display: flex;
        flex-direction: column;

        .breadcrumb {
            align-items: center;
            justify-content: center;

            .el-breadcrumb {
                font-size: 15px;
                line-height: 2;
            }
        }
    }
}
</style>

<style scoped>
.Select {
    margin: 10px 0px;
}

.SortManagement .edit_btn {
    width: auto !important;
    background: rgba(80, 197, 217, 1);
    border-radius: 14px !important;
    color: #fff;
    border: #50C5D9;
}

.SortManagement .edit_btn:hover,
.SortManagement .edit_btn:active,
.SortManagement .edit_btn:focus {
    background: rgba(80, 197, 217, 1);
    color: #fff;
    border: #50C5D9;
}

.SortManagement .del_btn2 {
    width: auto !important;
    background: #E7E7E7;
    border-radius: 14px !important;
    color: #555;
    border: #E7E7E7;
}

.SortManagement .del_btn2:hover,
.SortManagement .del_btn2:active,
.SortManagement .del_btn2:focus {
    background: #E7E7E7;
    color: #555;
    border: #E7E7E7;
}

.SortManagement .del_btn {
    width: auto !important;
    background: #FF5B6C;
    border-radius: 14px !important;
    color: #fff;
    border: #FF5B6C;
}

.SortManagement .del_btn:hover,
.SortManagement .del_btn:active,
.SortManagement .del_btn:focus {
    background: #FF5B6C;
    color: #fff;
    border: #FF5B6C;
}

.Img {
    margin-top: 15px;
}

.video {
    margin-top: 20px;
}
</style>

<style scoped>
>>>.el-dialog__body {
    padding: 10px 20px;
    height: 800%;
}

>>>.el-form-item {
    margin-bottom: 0px;
}

>>>.el-form--label-top .el-form-item__label {
    float: none;
    display: inline-block;
    text-align: left;
    padding: 0;
    line-height: 20px;
}

>>>.el-form-item__error {
    padding-top: 0px;
    top: 95%;
    left: auto;
    right: 0;
}
</style>
